var map = {
	"./admision.js": "99f1",
	"./auth.js": "c7d4",
	"./careers.js": "74b9",
	"./cepre.js": "776d",
	"./countries.js": "532d",
	"./districts.js": "306e",
	"./languages.js": "4493",
	"./layout.js": "3150",
	"./provinces.js": "a209",
	"./regions.js": "af0e",
	"./register.js": "78e2",
	"./schools.js": "833d",
	"./typeExams.js": "9380",
	"./typeUsers.js": "4e4c",
	"./universidades.js": "25e1",
	"./users.js": "8ce5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c17";